import Icon from '../components/Icon.vue'

Icon.register({"slash":{"width":640,"height":512,"paths":[{"d":"M594.5 508.6L6.2 53.9C-0.8 48.5-2 38.4 3.4 31.4L23 6.2C28.4-0.8 38.5-2.1 45.5 3.4L633.8 458.1C640.8 463.5 642.1 473.6 636.6 480.6L617 505.8C611.6 512.8 601.5 514 594.5 508.6z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/slash.js
// module id = null
// module chunks = 